import { Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutIntercompanyAssetInfo extends Layout {
    labelAssetDriver2Value: Label;
    labelAssetDriverValue: Label;
    labelAssetTractor: Label;
    labelAssetTractorValue: Label;
    labelAssetTrailerValue: Label;
    labelDriverOneName: Label;
    labelDriverTwoName: Label;
    labelTrailer: Label;
    panelICAsset: Panel;
    panelICAssetTractor: Panel;
    panelICAssetTrailer: Panel;
}
